import React from 'react';

const FormLabel = ({ text, htmlFor, required = false, className = '' }) => (
    <label htmlFor={htmlFor} className={`ow-form-label ${className}`.trim()}>
        {text}
        {required && <span className="ow-form-label__required" aria-hidden="true">*</span>}
    </label>
);

export default FormLabel;
